import { BrowserRouter as Router, useRoutes } from 'react-router-dom';

import Game from './Game';
import Presenter from './Presenter';
import Home from './Home';

import '../styles/App.scss';

const AppRouter = () => {
  const routes = useRoutes([
    { path: '/', element: <Home /> },
    { path: '/:meetingId', element: <Game /> },
    // { path: '/presenter', element: <Presenter /> },
    { path: '/presenter/:meetingId', element: <Presenter /> },
    { path: '/speaker/:meetingId', element: <Presenter isReadOnly={true}/> },
  ]);
  return routes;
};

const App = () => {
  return (
    <Router>
      <AppRouter />
    </Router>
  );
};

export default App;
